export default __webpack_public_path__ + "support-icon.5a139990579b35fe58ace491f91852c9.svg";